import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { ScaleLoader,BeatLoader } from "react-spinners"
import ProjectCard from '../ProjectCard'
import { Heading,MainContainer, Button, ProjectsContainer, CategoryBar, EachCategory, HighlightBar, Title, SubTitle, Loader,NoProjectsContainer } from './style.js'
import ThemeContext from '../../context/ThemeContext.js'


const apiStatusConstants = {
    success: "SUCCESS",
    failure: "FAILURE",
    loading: "IN_PROGRESS",
    initial: "INITIAL"
}

const categories = ['React', 'HTML & CSS', "JS", "AI", "CYBERSECURITY"]

const Projects = (props) => {
    const navigate = useNavigate()
    const [apiResponse, setApiResponse] = useState({
        status: null,
        data: null,
        errorMsg: null
    })
    const [projects, setProjects] = useState([])

    const [activeIndex, setActiveIndex] = useState(0); // index of category
    const categoryRefs = useRef([]);
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 });

    useEffect(() => {
        const activeEl = categoryRefs.current[activeIndex];
        if (activeEl) {
            setHighlightStyle({
                left: activeEl.offsetLeft,
                width: activeEl.offsetWidth
            });
        }
    }, [activeIndex]);

    useEffect(() => {
        const getProjects = async () => {
            setApiResponse(prev => ({ ...prev, status: apiStatusConstants.loading }))
            // let apiUrl;
            // apiUrl = `/projects?CATEGORY=${categories[activeIndex]}`
            // if(categories[activeIndex]==='HTML & CSS'){
            //     apiUrl = `/projects?CATEGORY=HTML %26 CSS` // %26 represents & in url
            // }
            const category = encodeURIComponent(categories[activeIndex]);
            const apiUrl = `https://portfoliobackend-l8ac.onrender.com/projects?CATEGORY=${category}`; //add backend url at front
            const response = await fetch(apiUrl)
            const data = await response.json()
            if (response.ok) {
                setApiResponse({
                    status: apiStatusConstants.success,
                    data,
                    errorMsg: null
                })
                setProjects(data)
            } else {
                setApiResponse({
                    status: apiStatusConstants.failure,
                    data: null,
                    errorMsg: data.error_msg
                })
            }
        }
        getProjects()
    }, [activeIndex])
    const onClickViewMore = () => {
        console.log(props)
        const category = encodeURIComponent(categories[activeIndex]);
        navigate(`/projects?CATEGORY=${category}`)
    }
    const renderFailureView = () => {
        return <ThemeContext.Consumer>
            {value => (
                <h1 style={{color:`${value.theme === 'light' ? '#5423a8' : '#FFFFFF'}`}}>Something went Wrong</h1>
            )}
        </ThemeContext.Consumer>
    }
    const renderLoadingView = () => {
        return <ThemeContext.Consumer>
            {value => (
                <Loader>
                    <ScaleLoader color={value.theme === 'light' ? '#5423a8' : '#FFFFFF'} width={10} height={40} speedMultiplier={2} barCount={4}/>
                </Loader>
            )}
        </ThemeContext.Consumer>
    }
    const renderSuccessView = () => {
        let filteredProjects = [];
        if (projects.length > 6) {
            filteredProjects = projects.slice(0, 6)
        } else {
            filteredProjects = projects
        }
        if (filteredProjects.length === 0) {
            return <ThemeContext.Consumer>
            {value => (
                <NoProjectsContainer>
                    <Heading theme={value.theme}>Projects Coming soon</Heading>
                    <BeatLoader color={value.theme === 'light' ? '#5423a8' : '#FFFFFF'} width={10} height={40}/>
                </NoProjectsContainer>
            )}
        </ThemeContext.Consumer>
        }
        //console.log(filteredProjects.length)
        return <>
            <ProjectsContainer>
                {filteredProjects.map(eachProject => <ProjectCard key={eachProject.id} details={eachProject} />)}
            </ProjectsContainer>
            <Button onClick={onClickViewMore}>View More</Button>
        </>
    }
    const renderProjects = () => {
        const { status } = apiResponse
        switch (status) {
            case apiStatusConstants.success:
                return renderSuccessView()
            case apiStatusConstants.failure:
                return renderFailureView()
            case apiStatusConstants.loading:
                return renderLoadingView()
            default:
                return null
        }
    }
    return (
        <MainContainer>
            <Title>Projects</Title>
            <SubTitle>we put your ideas and ths your wishes in form of a unique web project that inspires you and your customers.</SubTitle>
            <CategoryBar>
                <HighlightBar left={highlightStyle.left} width={highlightStyle.width} />
                {categories.map((cat, idx) => (
                    <EachCategory
                        key={cat}
                        active={idx === activeIndex}
                        ref={el => (categoryRefs.current[idx] = el)}
                        onClick={() => setActiveIndex(idx)}
                    >
                        {cat}
                    </EachCategory>
                ))}
            </CategoryBar>
            {renderProjects()}
        </MainContainer>
    )
}

export default Projects